import { createApiClient, type RequestOptions } from "@roskomkassa/frontend-shared";

let csrfToken = sessionStorage.getItem("rk-csrf") || "";

const configuredApiBase = (import.meta.env.VITE_WEB_API_BASE_URL || "").replace(/\/$/, "");
const webApiBase = `${configuredApiBase}/api/web`;
const request = createApiClient({
  baseUrl: webApiBase,
  credentials: "include",
  mutationHeaders: (): Record<string, string> => csrfToken ? { "X-CSRF-Token": csrfToken } : {},
});

export function setCsrf(value: string) {
  csrfToken = value;
  if (value) sessionStorage.setItem("rk-csrf", value);
  else sessionStorage.removeItem("rk-csrf");
}

export function getCsrf() {
  return csrfToken;
}

export async function api<T>(path: string, options: RequestOptions = {}): Promise<T> {
  return request<T>(path, options);
}

export const post = <T>(path: string, body: unknown, headers?: Record<string, string>) =>
  api<T>(path, { method: "POST", body: JSON.stringify(body), headers });

export const patch = <T>(path: string, body: unknown) =>
  api<T>(path, { method: "PATCH", body: JSON.stringify(body) });
